"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltipPopper = void 0;
var _TooltipPopper = require("./TooltipPopper");
// TODO: in v9, move styled() from TooltipPopper.jsx to here
var StyledTooltipPopper = _TooltipPopper.TooltipPopper;
exports.StyledTooltipPopper = StyledTooltipPopper;